import React from "react";

interface ArrowProps {
  stroke?: string;
  width?: number;
  height?: number;
  strokeWidth?: number;
  direction?: "left" | "right";
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

const ArrowBtn: React.FC<ArrowProps> = ({
  stroke = "#003F2D",
  width = 50,
  height = 50,
  strokeWidth = 2,
  direction = "left",
  onClick,
  disabled = false,
}) => {
  const rotation = direction === "right" ? 180 : 0;

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`inline-flex items-center justify-center border-none bg-transparent p-0 cursor-pointer disabled:cursor-not-allowed disabled:opacity-30`}
      type="button"
      style={{ borderRadius: "50%" }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 50 50"
        fill="none"
        style={{
          transform: `rotate(${rotation}deg)`,
        }}
        className="arrow-btn-responsive"
      >
        <path
          d="M35.0356 24.6555H14.2789M14.2789 24.6555L21.1068 32.4393M14.2789 24.6555L21.1068 16.8717M0.655304 24.6554C0.655304 11.4006 11.4005 0.655396 24.6553 0.655396C37.9101 0.655396 48.6553 11.4006 48.6553 24.6554C48.6553 37.9102 37.9101 48.6554 24.6553 48.6554C11.4005 48.6554 0.655304 37.9102 0.655304 24.6554Z"
          stroke={stroke}
          strokeWidth={strokeWidth}
        />
      </svg>
      <style>{`
        .arrow-btn-responsive {
          transition: all 0.2s ease;
        }
        
        @media (max-width: 620px) {
          .arrow-btn-responsive {
            width: 32px !important;
            height: 32px !important;
          }
        }
      `}</style>
    </button>
  );
};

export default ArrowBtn;
